import {createSvgIcon} from '../create-svg-icon';

export const PhonelinkEraseIcon = createSvgIcon(
  <path d="m13 8.2-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z" />
, 'PhonelinkEraseOutlined');
